import DeliveryDriverApi from "../../services/api/DeliveryDrivers";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getQueryParams, isValNull } from "../../utils";

function handleError(err) {
  console.log("error in delivery drivers actions :", err);
}

export const resetToInitialState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DELIVERY_DRIVERS,
    payload,
  };
};

export const setDriverActionReasons = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_ACTION_REASONS,
    payload,
  };
};

export const setDriverDocuments = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_DOCUMENTS,
    payload,
  };
};

export const setDriverBankStatus = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_BANK_STATUS,
    payload,
  };
};

export const setDriverProfessions = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_PROFESSIONS,
    payload,
  };
};

export const setDriverEducations = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_EDUCATIONS,
    payload,
  };
};

export const setDriverEducationQualifications = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_EDUCATION_QUALIFICATIONS,
    payload,
  };
};

export const setDriversCount = (payload) => {
  return {
    type: ActionTypes.SET_DRIVERS_COUNT,
    payload,
  };
};

export const setDriversList = (payload) => {
  return {
    type: ActionTypes.SET_DRIVERS_LIST,
    payload,
  };
};

export const setDriverBasicDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_BASIC_DETAILS,
    payload,
  };
};

export const setDriverAssignmentStatus = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_ASSIGNMENT_STATUS,
    payload,
  };
};

export const setDriverFinancialDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_FINANCIAL_DETAILS,
    payload,
  };
};

export const setDriverAdditionalDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_ADDITIONAL_DETAILS,
    payload,
  };
};

export const setDriverReservationDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_RESERVATION_DETAILS,
    payload,
  };
};

export const setDriverAssetDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_ASSET_DETAILS,
    payload,
  };
};

export const setDriverStoreMappingDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_STORE_MAPPING_DETAILS,
    payload,
  };
};

export const setDriverServicesDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_SERVICES_DETAILS,
    payload,
  };
};

export const setDriverLocalitiesDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_LOCALITIES_DETAILS,
    payload,
  };
};

export const setDriverLogsDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_LOGS_DETAILS,
    payload,
  };
};

export const setEligibleDriverServices = (payload) => {
  return {
    type: ActionTypes.SET_ELIGIBLE_DRIVER_SERVICES,
    payload,
  };
};

export const setDriverDeliveryStatuses = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_DELIVERY_STATUSES,
    payload,
  };
};

export const setDriverDeliveryServices = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_DELIVERY_SERVICES,
    payload,
  };
};

export const setDriverLifecycleStatuses = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_LIFECYCLE_STATUSES,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_DELIVERY_DRIVERS,
    payload,
  };
};


export const setDriverMigrationDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_MIGRATION_DETAILS,
    payload,
  };
};


export const resetState = (state) => async (dispatch) => {
  let payload = {
    state: state,
  };
  dispatch(resetToInitialState(payload));
};

export const resetIndividualDriverState = (payload = {}) => {
  return {
    type: ActionTypes.RESET_INDIVIDUAL_DRIVER_STATE,
    payload,
  };
};

export const getDriversCount = (params) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const finalParams = getQueryParams(params);
    let response = await DeliveryDriverApi.getDriversCount(finalParams);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriversCount(response.count));
      return response.count;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriversList = (params) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    dispatch(setActiveFilters(params));
    const finalParams = getQueryParams(params);
    let response = await DeliveryDriverApi.getDriversList(finalParams);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriversList(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverBasicDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverBasicDetails(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverBasicDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverAssignmentStatus = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverAssignmentStatus(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverAssignmentStatus(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
export const updateDriverAssignmentStatus =
  (driverId, payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.updateDriverAssignmentStatus(
        driverId,
        payload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
          })
        );
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const updateDriverBasicDetails =
  (driverId, payload, updatedState, otp) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      const finalPayload = {
        basic_details: payload,
      };
      if (otp) {
        finalPayload["otp"] = otp;
      }
      let response = await DeliveryDriverApi.updateDriverBasicDetails(
        driverId,
        finalPayload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
          })
        );
        if (!isValNull(updatedState["zone_id"])) {
          updatedState["zone_enabled"] = true;
        }
        dispatch(setDriverBasicDetails({ basic_details: updatedState }));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.UPDATION_FAILURE,
        })
      );
      handleError(err);
      if (err.includes("OTP Verification")) {
        return { status: { code: 897, message: err } };
      }
    }
  };

export const getOTPDriverBasicDetails =
  (driverId, payload, isResend = false) =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      const finalPayload = {
        basic_details: payload,
      };
      let response = await DeliveryDriverApi.getOTPDriverBasicDetails(
        driverId,
        finalPayload,
        isResend
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.OTP_SEND_SUCCESS,
          })
        );
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const updateDriverAdditionalDetails =
  (driverId, payload, updatedState, otp) => async (dispatch) => {
    try {
      const finalPayload = { ...payload };
      if (otp) {
        finalPayload["otp"] = otp;
      }
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.updateDriverAdditionalDetails(
        driverId,
        finalPayload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
          })
        );
        dispatch(setDriverAdditionalDetails(updatedState));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.UPDATION_FAILURE,
        })
      );
      handleError(err);
      if (err.includes("OTP Verification")) {
        return { status: { code: 897, message: err } };
      }
    }
  };

export const updateDriverDocuments =
  (driverId, documents, action = null) =>
  async (dispatch) => {
    try {
      const finalPayload = { documents: [], action_type: action };
      for (var key of Object.keys(documents)) {
        finalPayload.documents.push({
          document_type: key,
          attachment: documents[key].attachment,
        });
      }

      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.updateDriverDocuments(
        driverId,
        finalPayload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
          })
        );
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.UPDATION_FAILURE,
        })
      );
      handleError(err);
      throw err;
    }
  };

export const getOTPDriverAdditionalDetails =
  (driverId, payload, isResend = false) =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.getOTPDriverAdditionalDetails(
        driverId,
        payload,
        isResend
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.OTP_SEND_SUCCESS,
          })
        );
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverAdditionalDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverAdditionalDetails(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverAdditionalDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverAssetDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverAssetDetails(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverAssetDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverStoreMappingDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverStoreMappingDetails(
      driverId
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverStoreMappingDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverReservationDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverReservationDetails(
      driverId
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverReservationDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverServicesDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverServicesDetails(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverServicesDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateDriverServicesDetails =
  (driverId, payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.updateDriverServicesDetails(
        driverId,
        payload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
          })
        );
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.UPDATION_FAILURE,
        })
      );
      handleError(err);
    }
  };

export const getEligibleDriverServices = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getEligibleDriverServices(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setEligibleDriverServices(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverLocalitiesDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverLocalitiesDetails(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverLocalitiesDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateDriverLocalitiesDetails =
  (driverId, payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      const finalPayload = {
        locality_preferences: payload,
      };
      let response = await DeliveryDriverApi.updateDriverLocalitiesDetails(
        driverId,
        finalPayload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
          })
        );
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.UPDATION_FAILURE,
        })
      );
      handleError(err);
    }
  };

export const updateDriverFinancialDetails =
  (driverId, payload, updatedState, otp) => async (dispatch) => {
    try {
      const finalPayload = { ...payload };
      if (otp) {
        finalPayload["otp"] = otp;
      }
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.updateDriverFinancialDetails(
        driverId,
        finalPayload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
          })
        );
        dispatch(setDriverFinancialDetails(updatedState));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.UPDATION_FAILURE,
        })
      );
      handleError(err);
      if (err.includes("OTP Verification")) {
        return { status: { code: 897, message: err } };
      }
    }
  };

export const getOTPDriverFinancialDetails =
  (driverId, payload, isResend = false) =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.getOTPDriverFinancialDetails(
        driverId,
        payload,
        isResend
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.OTP_SEND_SUCCESS,
          })
        );
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverFinancialDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverFinancialDetails(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverFinancialDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverLogsDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverLogsDetails(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverLogsDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverDeliveryServices = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverDeliveryServices();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverDeliveryServices(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverDeliveryStatuses = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverDeliveryStatuses();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverDeliveryStatuses(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverLifecycleStatuses = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverLifecycleStatuses();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverLifecycleStatuses(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverProfessions = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverProfessions();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverProfessions(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverEducations = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverEducations();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverEducations(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverEducationQualifications = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverEducationQualifications();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverEducationQualifications(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverActionReasons = (action) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverActionReasons(action);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverActionReasons(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const driverVerifyPhoneNumberChange =
  (driverId, phoneNo) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.driverVerifyPhoneNumberChange(
        driverId,
        phoneNo
      );
      dispatch(setLoader(false));
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverBankVerificationStatus =
  (driverId, payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.getDriverBankVerificationStatus(
        driverId,
        payload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverBankStatus(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const verifyDriverBankDetails =
  (driverId, payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DeliveryDriverApi.verifyDriverBankDetails(
        driverId,
        payload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverBankStatus(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const terminateDriver = (driverId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.terminateDriver(driverId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const resignDriver = (driverId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.resignDriver(driverId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const forceOfflineDriver = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.forceOfflineDriver(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const clearSelfieCampaignDriver = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.clearSelfieCampaignDriver(driverId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const notifyDriver = (driverId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.notifyDriver(driverId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverDocuments = (driverId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverDocuments(
      driverId,
      payload
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverDocuments(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const verifyDriverDocuments = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.verifyDriverDocuments(payload);
    const status = response?.status?.code;
    dispatch(setLoader(false));
    if (response && status == 200) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
      return response;
    } else {
      const error = response.errors;
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof error === "string" ? error : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(error);
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverMigrationDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DeliveryDriverApi.getDriverMigrationDetails(
      driverId
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverMigrationDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
